import { section } from '@/glow';
import Carousel from '@/lib/carousel';
import { ProductItem } from '@/lib/animation/';

section('featured-collection', {
  onLoad() {
    const carouselWraps = this.container.dataset.carouselWraps === 'true';
    this.carousel = Carousel(this.container, 'featured-collection', {
      wrapAround: carouselWraps,
    });

    this.itemAnimation = ProductItem(this.container);
  },

  onUnload() {
    this.carousel.destroy();
    this.itemAnimation && this.itemAnimation.destroy();
  },
});
